import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";
import { BLOG_POSTS, NEWS_POSTS } from "../data/mediaContent";

const MediaInsights = () => (
  <Fragment>
    <MetaTags>
      <title>Media & Insights | South Asia Consultancy</title>
      <meta
        name="description"
        content="Latest oil rig technology, automation news, and manpower insights from global offshore and onshore operations."
      />
    </MetaTags>
    <LayoutOne>
      <SectionHeroBanner title="Media & Insights" className="sectionAboutBg" />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Media Hub" className="text-center" position="center" width="180px" />
        <p className="sac-intro text-center">
          Explore dedicated SEO pages for long-form blogs and industry news on rig technology, workforce strategy, and
          operations excellence.
        </p>

        <div className="row mt-4">
          {BLOG_POSTS.slice(0, 4).map((post) => (
            <article key={post.slug} className="col-md-6 mb-4">
              <div className="sac-content-card h-100">
                <p className="sac-badge mb-2">Blog</p>
                <h2 className="MainTitle" style={{ fontSize: "22px" }}>
                  {post.title}
                </h2>
                <p className="text-muted mb-2" style={{ fontSize: "12px", letterSpacing: "0.3px", textTransform: "uppercase" }}>
                  {post.date}
                </p>
                <p className="fs16px lnh-30">{post.excerpt}</p>
                <Link to={`/media/blog/${post.slug}`} className="color-primary fw600">
                  Read blog
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="row">
          {NEWS_POSTS.slice(0, 4).map((post) => (
            <article key={post.slug} className="col-md-6 mb-4">
              <div className="sac-content-card h-100">
                <p className="sac-badge mb-2">News</p>
                <h2 className="MainTitle" style={{ fontSize: "22px" }}>
                  {post.title}
                </h2>
                <p className="text-muted mb-2" style={{ fontSize: "12px", letterSpacing: "0.3px", textTransform: "uppercase" }}>
                  {post.date}
                </p>
                <p className="fs16px lnh-30">{post.excerpt}</p>
                <Link to={`/media/news/${post.slug}`} className="color-primary fw600">
                  Read news
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="row mt-2">
          <div className="col-md-6 mb-3">
            <div className="sac-content-card h-100">
              <MainTitle text="All Blogs" position="left" width="110px" />
              <p className="fs16px lnh-30">10 SEO-focused long-form blog pages.</p>
              <Link to="/media/blog" className="color-primary fw600">
                View all blog posts
              </Link>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="sac-content-card h-100">
              <MainTitle text="All News" position="left" width="110px" />
              <p className="fs16px lnh-30">10 SEO-focused industry news pages.</p>
              <Link to="/media/news" className="color-primary fw600">
                View all news posts
              </Link>
            </div>
          </div>
        </div>
      </div>
    </LayoutOne>
  </Fragment>
);

export default MediaInsights;
